import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { DEFAULT_LANGUAGE, LANGUAGE_OPTIONS } from 'utils/constants';

/**
 * Contexto para manejar literales en toda la aplicación
 */

const LanguageContext = createContext<any>({});
const SetLanguageContext = createContext<any>({});
const TranslateContext = createContext<any>({});
const LANGUAGES = LANGUAGE_OPTIONS.map((lang) => lang.value);

const strings = {
  es: require('resources/i18/es').strings,
  en: require('resources/i18/en').strings,
  ca: require('resources/i18/ca').strings,
  de: require('resources/i18/de').strings,
};

/**
 *
 * @param {el literal a traducir} key
 * @param {lenguaje que se traduce} language
 * Tenemos en cuenta que puede ser un objeto nested como los meses que van asociados a un numero del 1/12
 * Ejemplo en ButtonDateOpenModal
 * @returns
 */
function translate(key, language) {
  const nestedKey = '$#';
  let nestedLanguage = key?.split(nestedKey);
  let literal = null;
  if (!key && !language && !strings[language] && nestedLanguage.length > 0) {
    literal = strings[language][nestedLanguage[0]][nestedLanguage[1]];
  }

  if (literal != null) {
    return literal;
  } else {
    return strings[language][key] || `${language}:${key}`;
  }
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(window.location.pathname.split('/')[1] && LANGUAGES.includes(window.location.pathname.split('/')[1]) ? window.location.pathname.split('/')[1] : DEFAULT_LANGUAGE);

  const t = useCallback((key) => translate(key, language), [language]);

  /* Obtiene el idioma guardado en local */
  const getStoredLanguage = async () => {
    const validLangs = Object.keys(strings);
    if (window.location.pathname.split('/')[1]) {
      let idiomaLocal = window.location.pathname.split('/')[1];
      idiomaLocal && validLangs.includes(idiomaLocal) && setLanguage(idiomaLocal);
    } else {
      try {
      let idiomaLocal = localStorage.getItem('userLanguage');
      const lenguaje =
        idiomaLocal && validLangs.includes(idiomaLocal) ? idiomaLocal : getLanguage();
      setLanguage(lenguaje);
    } catch (error) {}
    }
    
  };

  /* Modifica el idioma al que se haya cambiado y lo guarda en memoria */
  const setIdioma = async function (lng) {
    if (LANGUAGES.includes(lng)) {
      setLanguage(lng);
      localStorage.setItem('userLanguage', lng);
    }
  };

  /* Inicializar el idioma con el guardado en local */
  useEffect(() => {
    getStoredLanguage();
  }, [language]);

  /* Obtener el idioma a partir del más acorde con el dispositivo del usuario */
  const getLanguage = () => {
    try {
      let lng = null;
      if (lng !== undefined && lng !== null) {
        return lng;
      }
      return DEFAULT_LANGUAGE;
    } catch (error) {
      return DEFAULT_LANGUAGE;
    }
  };

  return (
    <LanguageContext.Provider value={language}>
      <SetLanguageContext.Provider value={setIdioma}>
        <TranslateContext.Provider value={t}>{children}</TranslateContext.Provider>
      </SetLanguageContext.Provider>
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export function useSetLanguage() {
  return useContext(SetLanguageContext);
}

export function useTranslate() {
  return useContext(TranslateContext);
}
